import React from "react";
import logo from "../../assets/dark-logo-text-new.png";

type FullScreenLoaderProps = {
  isLoading: boolean;
};

const FullScreenLoader: React.FC<FullScreenLoaderProps> = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div>
      {" "}
      <div className="fixed inset-0 z-40 flex items-center justify-center backdrop-blur-md bg-base-100/70">
        <div className="flex flex-col items-center gap-4 p-6 pt-0 rounded-xl">
          {/* Chevron/Text - in front */}
          <h1 className="text-base-content text-[12rem] font-light font-groteskLogo animate-pulse-custom relative z-10">
            ^
          </h1>
          <p className="text-md -mt-40 font-medium text-base-content font-grotesk text-center">
            Loading...
          </p>
        </div>
      </div>
    </div>
  );
};

export default FullScreenLoader;
